import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import onlinePaymentsApi from '@/features/dashboard/onlinePayments/api/onlinePaymentsApi.ts';

interface InitiatePublicPaymentParams {
  orgSlug: string;
  token: string;
  plannedTransactionId: string;
  provider: 'TPAY';
  successUrl: string;
  errorUrl: string;
}

export const useInitiatePublicPayment = () => {
  return useMutation({
    mutationFn: async ({
      orgSlug,
      token,
      plannedTransactionId,
      provider,
      successUrl,
      errorUrl,
    }: InitiatePublicPaymentParams) => {
      return onlinePaymentsApi.initiatePublicPayment(
        orgSlug,
        { plannedTransactionId, provider, successUrl, errorUrl },
        token,
      );
    },
    onSuccess: (data) => {
      window.location.href = data.paymentUrl;
    },
    onError: (error) => {
      toast.error('Błąd', { description: error.message });
    },
  });
};
